var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import moment from 'moment';
import GLOBAL_VUE from '../../globalVue';
import RequiredMixin from '../../components/renderHeader/RequiredMixin';
import { numSub, numMulti } from '@/helper/calucate';
import RejectStockInOrderService from '../../api/RejectStockInOrderService';
import Header from './components/AddHeader.vue';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 300;
        _this.order_id = '';
        _this.formData = {
            order_money: '',
            warehouse_date: '',
            order_icomment: '',
        };
        _this.data = [];
        _this.dialogVisible = false;
        _this.reject_reason = '';
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = RejectStockInOrderService.getInstance();
        this.getDetail();
    };
    default_1.prototype.countOrderMoney = function () {
        var money = 0;
        this.data.map(function (item) {
            money = _.add(money, item.order_detail_money);
        });
        this.formData.order_money = new Number(money).toFixedNoZero(2);
    };
    default_1.prototype.changeGoodRow = function (row, type) {
        if (type === 'order_warehousing_amount' || type === 'order_loss_amount') {
            if (row.order_warehousing_amount > row.order_detail_amount) {
                row.order_warehousing_amount = row.order_detail_amount;
            }
            if (row.order_loss_amount > row.order_detail_amount) {
                row.order_loss_amount = row.order_detail_amount;
            }
            if (row.order_warehousing_amount) {
                row.order_warehousing_amount = parseFloat(row.order_warehousing_amount).toFixed(4) - 0;
            }
            if (row.order_loss_amount) {
                row.order_loss_amount = parseFloat(row.order_loss_amount).toFixed(4) - 0;
            }
            if (type === 'order_warehousing_amount') {
                row.order_loss_amount = parseFloat(numSub(row.order_detail_amount, row.order_warehousing_amount)).toFixed(4) - 0;
            }
            if (type === 'order_loss_amount') {
                row.order_warehousing_amount = parseFloat(numSub(row.order_detail_amount, row.order_loss_amount)).toFixed(4) - 0;
            }
            row.order_detail_money = parseFloat(numMulti(row.order_warehousing_amount, row.order_detail_uprice)).toFixed(2) - 0;
            this.countOrderMoney();
        }
        console.log('changeGoodRow>>>', type);
    };
    default_1.prototype.save = function () {
        var _this = this;
        var params = __assign({ order_id: this.order_id }, this.formData, { data: JSON.stringify(this.data) });
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .update(params)
            .then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            var timeout = setTimeout(function () {
                clearTimeout(timeout);
                GLOBAL_VUE.$emit('closeTab', _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
            }, 500);
            window._czc.push(['_trackEvent', '修改退货入库单', '保存', '保存']);
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.order_id,
        };
        this.service
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.formData = Object.assign({}, _this.formData, {
                order_code: data.order_code,
                purchase_reject_order_code: data.purchase_reject_order_code,
                order_money: data.order_money,
                organ_id: data.organ_id,
                organ_name: data.organ_name,
                warehouse_date: data.warehouse_date || moment().format('YYYY-MM-DD'),
                business_name: data.business_name,
                shop_name: data.shop_name,
                order_icomment: data.order_icomment,
            });
            _this.order_type = data.order_type;
            _this.data = Array.isArray(data.detail) ? data.detail : [];
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.closeReject = function () {
        this.dialogVisible = false;
    };
    default_1.prototype.reject = function () {
        this.dialogVisible = true;
        this.reject_reason = '';
    };
    default_1.prototype.doReject = function () {
        var _this = this;
        if (this.reject_reason.length > 100) {
            this.$message.error('驳回原因不能超过100字');
            return;
        }
        var params = {
            order_ids: this.order_id,
            reject_reason: this.reject_reason,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.reject(params).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg || '操作成功');
            _this.closeReject();
            var timeout = setTimeout(function () {
                clearTimeout(timeout);
                GLOBAL_VUE.$emit('closeTab', _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
            }, 500);
            window._czc.push([
                '_trackEvent',
                '修改退货入库单',
                '退货入库单驳回',
            ]);
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.audit = function (type) {
        var _this = this;
        this.$confirm('审核后将不能修改，确定审核吗？').then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var order_ids = _this.order_id;
            _this.service.audit({
                order_ids: order_ids,
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success(res.data.msg || '操作成功');
                }
                window._czc.push([
                    '_trackEvent',
                    '退货入库单',
                    '退货入库单废弃',
                ]);
                var timeout = setTimeout(function () {
                    clearTimeout(timeout);
                    GLOBAL_VUE.$emit('closeTab', _this);
                    if (_this.opener) {
                        _this.opener.getList();
                    }
                }, 500);
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    default_1 = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
